import { useState, useEffect } from 'react';

import { IEvent, IEventData, IGroupedEvents } from '../types';

import formatDate from 'helpers/formatDate';

export default useAllGroupedEvents;

function useAllGroupedEvents(
  eventData: IEventData,
  entityId?: string
): [IGroupedEvents | undefined, number] {
  const [groupedEvents, setGroupedEvents] = useState<IGroupedEvents>();
  const [totalEvents, setTotalEvents] = useState(0);

  useEffect(() => {
    if (!eventData || eventData.totalEvents === 0 || !entityId) return;
    const { events } = eventData;
    const filterByEntityId = filterById(entityId);
    const eventsForArtist = events.filter(filterByEntityId);
    const grouped = eventsForArtist.reduce(groupByDay, {});

    setGroupedEvents(eventsForArtist.length > 0 ? grouped : undefined);
    setTotalEvents(eventsForArtist.length);
  }, [eventData, entityId]);

  return [groupedEvents, totalEvents];
}

function filterById(entityId: string) {
  return function (event: IEvent): boolean {
    return event.relatedEntity.id === entityId;
  };
}

function groupByDay(acc: IGroupedEvents, event: IEvent): IGroupedEvents {
  const date = new Date(event.eventTimestamp);
  const day = formatDate(date, 'day', true);
  const year = formatDate(date, 'year', true);
  const formattedDate = `${day}, ${year}`;
  const entry = acc[formattedDate];

  if (entry) entry.push(event);
  else acc[formattedDate] = [event];

  return acc;
}
